export default "__VITE_ASSET__N5RA6dYv__"